import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CouriersWithItinerariesOverPeriodQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date'];
  endDate: Types.Scalars['Date'];
  agencyId: Types.Scalars['ID'];
}>;


export type CouriersWithItinerariesOverPeriodQuery = { __typename?: 'Query', CouriersWithItinerariesOverPeriod: Array<{ __typename?: 'Courier', courierId: number, indicative?: string | null, etaInterval: number }> };


export const CouriersWithItinerariesOverPeriodDocument = gql`
    query CouriersWithItinerariesOverPeriod($startDate: Date!, $endDate: Date!, $agencyId: ID!) {
  CouriersWithItinerariesOverPeriod(
    startDate: $startDate
    endDate: $endDate
    agencyId: $agencyId
  ) {
    courierId
    indicative
    etaInterval
  }
}
    `;

/**
 * __useCouriersWithItinerariesOverPeriodQuery__
 *
 * To run a query within a React component, call `useCouriersWithItinerariesOverPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouriersWithItinerariesOverPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouriersWithItinerariesOverPeriodQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useCouriersWithItinerariesOverPeriodQuery(baseOptions: Apollo.QueryHookOptions<CouriersWithItinerariesOverPeriodQuery, CouriersWithItinerariesOverPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouriersWithItinerariesOverPeriodQuery, CouriersWithItinerariesOverPeriodQueryVariables>(CouriersWithItinerariesOverPeriodDocument, options);
      }
export function useCouriersWithItinerariesOverPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouriersWithItinerariesOverPeriodQuery, CouriersWithItinerariesOverPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouriersWithItinerariesOverPeriodQuery, CouriersWithItinerariesOverPeriodQueryVariables>(CouriersWithItinerariesOverPeriodDocument, options);
        }
export type CouriersWithItinerariesOverPeriodQueryHookResult = ReturnType<typeof useCouriersWithItinerariesOverPeriodQuery>;
export type CouriersWithItinerariesOverPeriodLazyQueryHookResult = ReturnType<typeof useCouriersWithItinerariesOverPeriodLazyQuery>;
export type CouriersWithItinerariesOverPeriodQueryResult = Apollo.QueryResult<CouriersWithItinerariesOverPeriodQuery, CouriersWithItinerariesOverPeriodQueryVariables>;